import React from 'react';

interface BouncingDotsProps {
  isWhite?: boolean;
}

export const BouncingDots: React.FC<BouncingDotsProps> = ({ isWhite = false }) => (
  <div className="flex space-x-1.5 items-center h-[36px]">
    <div className={`w-2.5 h-2.5 rounded-full ${isWhite ? 'bg-white' : 'bg-gray-400'} animate-bounce`} style={{ animationDelay: '0ms' }}></div>
    <div className={`w-2.5 h-2.5 rounded-full ${isWhite ? 'bg-white' : 'bg-gray-400'} animate-bounce`} style={{ animationDelay: '150ms' }}></div>
    <div className={`w-2.5 h-2.5 rounded-full ${isWhite ? 'bg-white' : 'bg-gray-400'} animate-bounce`} style={{ animationDelay: '300ms' }}></div>
  </div>
);
